<template>
    <div :class="['messageBoardContainer',accessType=='pc'?'messageBody':'']" v-loading.fullscreen.lock="fullscreenLoading">
        <div v-if="hasBack" class="headerTip">
            <img :src="delPng" style="position:absolute;left:.4522rem;cursor:pointer;width: .28rem;top: 0.8rem;"  @click="goBack">
            <div>请您留言</div>
        </div>
        <el-form ref="form" :model="form" label-width="3.262rem" :rules="rules"  class="demo-ruleForm">
            <el-form-item label="反馈人:" prop="feedback">
                <el-row>
                    <el-col :span="24" style="padding-right: 0">
                        <el-select v-model="form.feedback" :disabled="isReadOnly" class="phone" placeholder="请选择反馈人">
                            <el-option
                                    v-for="item in form.options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-row>
            </el-form-item>
            <el-form-item label="姓名:" prop="name">
                <el-row>
                    <el-col :span="24" style="padding-right: 0">
                        <el-input v-model="form.name" :disabled="isReadOnly" class="phone" placeholder="请填写姓名"></el-input>
                    </el-col>
                    <!-- <el-col :span="8" class="tr">
                       <el-button :disabled="isReadOnly" type="primary"  size="small" @click="update">自动获取</el-button>
                     </el-col> -->
                </el-row>
            </el-form-item>
            <el-form-item label="绑定账号:" prop="account">
                <el-row>
                    <el-col :span="24" style="padding-right: 0">
                        <el-input v-model="form.account" :disabled="isReadOnly" class="phone" placeholder="请填写账号"></el-input>
                    </el-col>
                    <!-- <el-col :span="8" class="tr">
                       <el-button :disabled="isReadOnly" type="primary"  size="small" @click="update">自动获取</el-button>
                     </el-col> -->
                </el-row>
            </el-form-item>
            <el-form-item label="被推荐人VIN:" prop="vin">
                <el-row>
                    <el-col :span="24" style="padding-right: 0">
                        <el-input v-model="form.vin" :disabled="isReadOnly" class="phone" placeholder="请填写车架号"></el-input>
                    </el-col>
                    <!-- <el-col :span="8" class="tr">
                       <el-button :disabled="isReadOnly" type="primary"  size="small" @click="update">自动获取</el-button>
                     </el-col> -->
                </el-row>
            </el-form-item>
            <el-form-item label="联系电话:" prop="phone">
                <el-row>
                    <el-col :span="24" style="padding-right: 0">
                        <el-input v-model="form.phone" :disabled="isReadOnly" class="phone" placeholder="请输入手机号"></el-input>
                    </el-col>
                    <!-- <el-col :span="8" class="tr">
                       <el-button :disabled="isReadOnly" type="primary"  size="small" @click="update">自动获取</el-button>
                     </el-col> -->
                </el-row>
            </el-form-item>
            <el-form-item label="问题描述:" prop="msg" class="ml-0">
                <el-row>
                    <el-col :span="24" style="padding-right: 0">
                        <el-input type="textarea" v-model="form.msg" :disabled="isReadOnly" resize="none" :maxlength="maxCount"
                          show-word-limit :rows="rows" @input="checked" :class="{'unValidate': !isValidate}" @focus="inputFocus"
                          placeholder="请填写您遇到的问题，以便妥善处理您的问题。"></el-input>
                    </el-col>
                </el-row>
            </el-form-item>
            <el-form-item class="ml-0">
                <el-button :type="isReadOnly ? 'info' : 'primary'" @click="submitForm()" :disabled="isReadOnly" round class="w-100">{{isReadOnly?'已提交':'提交表单'}}</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    const MAX_COUNT = 300
    import authAPI from '@/api/api.js'
    import message from '@/utils/message'
    import delPng from '@/assets/image/del.png'
    export default {
        name: 'messageLeaveDouble',
        data () {
            let validatePhone = (rule, value, callback)=> {
                if (!value) {
                    return callback(new Error('手机号码不能为空'))
                } else {
                    let phone = value.replace(/\s/g, '')
                    if (!(/^1[3456789]\d{9}$/.test(phone))) {
                        return callback(new Error('请输入正确的手机号码'))
                    }
                    callback()
                }
            }
            let validateAccount = (rule, value, callback)=> {
                if (!value) {
                    return callback(new Error('绑定账号不能为空'))
                } else {
                    let phone = value.replace(/\s/g, '')
                    if (!(/^\d{11}$/.test(phone))) {
                        return callback(new Error('请输入正确的绑定账号'))
                    }
                    callback()
                }
            }
            let validateVIN = (rule,value,callback)=> {
                if(!value) {
                    return callback(new Error('vin不能为空'))
                }else {
                    const regEn = /[`~!@#$%^&*()_+<>?:"{},./;'[\]]/im
                    const regCn = /[·！#￥（—）：；“”‘、，|《。》？【】[\]]/im
                    const regNumLetter = /[^\w/]/gi

                    if (regEn.test(value) || regCn.test(value) || regNumLetter.test(value)) {
                        return callback(new Error('请输入正确的vin'))
                    }
                    if (value.length !== 17) {
                        return callback(new Error('请输入正确的vin'))
                    }
                    callback()
                }
            }
            return {
                form: {
                    options: [{value: '推荐人', label: '推荐人'},{value: '被推荐人', label: '被推荐人'}],
                    u_cust_id:'',
                    session_id:'',
                    access_id:'',
                    type:'',
                    oid:'',
                    feedback: '',
                    name: '',
                    account: '',
                    vin: '',
                    is_msg: 1,
                    phone:'',
                    content:'',
                    is_service: ''
                },
                fullscreenLoading: true,
                delPng:delPng,
                rules: {
                    feedback: [{required: true, message: '反馈人不能为空'}],
                    name: [{required:true, message: '姓名不能为空'}],
                    account: [{required:true, validator: validateAccount, trigger: ['change','blur']}],
                    vin: [{required:true, validator: validateVIN, trigger: ['change', 'blur']}],
                    phone: [{required: true, validator: validatePhone, trigger: ['change','blur']}]
                },
                isReadOnly: false,
                isValidate: true,
                rows:'8',
                maxCount: MAX_COUNT,
                accessType:'mobile',//pc端 移动端
                params:'',
                hasBack: false,
                saveParams:''
            }
        },
        created() {
            document.title = '请您留言'
            if(/Windows|Macintosh/i.test(navigator.userAgent)) {
                this.accessType = 'pc'
                this.rows = '5'
            }else{
                this.accessType = 'mobile'
                this.rows ='8'
            }
            this.params = this.$route.query
            this.hasBack = this.$route.query.from&&this.$route.query.from=='H5'
            // this.getMessageType()
            this.checkMsgByCustId()
        },
        methods: {
            goBack() {
                this.$router.go('-1')
            },
            submitForm () {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.isReadOnly = true
                        this.sendLeaveMessage()
                    } else {
                        return false
                    }
                })
            },
            checkMsgByCustId() {
                authAPI.checkLeaveMessage({'u_cust_id':this.params.u_cust_id,'oid':this.params.oid, 'is_msg': 1, 'session_id': this.params.session_id, 'sign':this.params.sign}).then(res=>{
                    // file：是否开启附件（0：否，1：是）
                    if(res) {
                        this.fullscreenLoading = false
                        if(res.code == '0') {
                            this.$message.warning(res.msg)
                            this.isReadOnly = true
                            this.form = {
                                u_cust_id:res.result.u_cust_id,
                                session_id:res.result.session_id,
                                access_id:res.result.access_id,
                                type:res.result.type,
                                oid:res.result.oid,
                                feedback: res.result.feedback,
                                name: res.result.name,
                                account: res.result.account,
                                vin: res.result.vin,
                                is_msg: res.result.is_msg,
                                phone: res.result.phone,
                                msg: res.result.content,
                                is_service:res.result.is_service
                            }
                            this.fileList = []
                            let files = []
                            try {
                                files =	JSON.parse(res.result.files)
                            } catch (error) {
                                files = []
                            }
                            files.forEach(item=>{
                                this.fileList.push({'url':item})
                            })
                        }else if(res.code == '-1') {
                            this.fileList = []
                            this.isReadOnly = true
                            message(res.msg)
                        }else{
                            this.fileFlag = res.file
                            this.fileList = []
                            this.isReadOnly = false
                        }
                        this.saveParams = res.data
                    }else{
                        this.isReadOnly = true
                        message(res.msg)
                    }
                }).catch(()=>{
                    this.isReadOnly = false
                })
            },
            sendLeaveMessage() {
                if(this.isReadOnly) {
                    let params = {
                        u_cust_id:this.params.u_cust_id || this.saveParams.u_cust_id,
                        session_id: this.params.session_id || this.saveParams.session_id,
                        access_id: this.params.access_id || this.saveParams.access_id,
                        type: this.params.type || this.saveParams.type,
                        oid: this.params.oid || this.saveParams.oid,
                        feedback: this.form.feedback,
                        name: this.form.name,
                        account: this.form.account,
                        vin: this.form.vin,
                        is_msg: 1,
                        phone:this.form.phone.replace(/\s/gi,''),
                        content:this.form.msg,
                        is_service: this.params.is_service || this.saveParams.is_service,
                    }
                    authAPI.sendLeaveMessage(params).then(res=>{
                        if(res.ret==200) {
                            message('提交成功！请耐心等待客服人员回复')
                            setTimeout(function () {
                                this.goBack()
                            }, 3000)
                        }else{
                            this.isReadOnly=false
                            message(res.msg)
                        }
                    }).catch(()=>{
                        this.isReadOnly = false
                    })
                }

            },
            checked() {
                if (this.form.msg.length >= MAX_COUNT) {
                    this.isValidate = false
                    return
                }
                this.isValidate = true
            },
            update() {
                authAPI.getPhone({'u_cust_id':this.params.u_cust_id}).then(res=>{
                    if(res.ret==200&&res.data!='') {
                        this.form.phone = res.data.replace(/(\d{3})(\d{0,4})(\d{0,4})/, '$1 $2 $3')
                    }else{
                        message(res.msg||''+' 请手动输入')
                    }
                }).catch(()=>{})
            },
            inputFocus(event) {
                setTimeout(function () {
                    let docHeight = window.innerHeight,
                        bottom = event.target.getBoundingClientRect().bottom,
                        scrollHeight = bottom-docHeight
                    if(scrollHeight>0) {
                        document.body.scrollTop =  scrollHeight+document.body.scrollTop+10
                    }
                },400)
            }
        },
        watch: {
            'form.phone'(newValue, oldValue) { // 监听
                if(!newValue)return
                this.form.phone = newValue.length > oldValue.length ? newValue.replace(/\s/g, '').replace(/(\d{3})(\d{0,4})(\d{0,4})/, '$1 $2 $3') : this.form.phone.trim()
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .messageBoardContainer{
        width $width
        height $height
        background $white
        padding .532rem 0.4522rem .266rem .4522rem
        box-sizing border-box
        font-size .3724rem
        .title {
            color $title-grey
            margin 0
            line-height .6384rem
            font-weight 400
            font-family: PingFangSC-Regular, PingFang SC;
        }
        .demo-ruleForm{
            padding-top .5321rem
        }
        .tr{
            text-align right
        }
        .w-100{
            width 100%
        }
    }
    .headerTip{
        padding-bottom 20px
        text-align center
        font-size .468rem
        line-height .78rem
    }
    @media screen and (max-width: 924px) {
        .messageBody{
            height: calc(100vh - 40px) !important;
            width: 100vw !important;
            overflow: auto;
        }
    }
    @media screen and (min-width: 925px) {
        .messageBody{
            height: 86vh !important;
            width: 44vw !important;
            margin: auto  !important;
            left: 28%  !important;
            top: 7%  !important;
            box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.1)  !important
            position: absolute;
            overflow: auto;
        }
    }
</style>
<style lang="stylus">
    .messageBoardContainer{
        .el-form-item__label,
        .el-form-item__content,
        .el-input,
        .el-input__inner,
        .el-textarea__inner{
            font-size .3724rem
            text-align left
        }
        .el-button{
            font-size .3724rem
        }
        .el-select{
            width 100%
        }
        .el-button--small{
            font-size .3192rem
            padding-left .1995rem
            padding-right .1995rem
        }
        .phone{
            .el-input__inner{
                //   border 0
            }
        }
        .ml-0{
            .el-form-item__content{
                margin-left 0!important
            }
        }
        .unValidate{
            .el-input__count{
                color #D88D8D
            }
            .el-textarea__inner{
                border-color #D88D8D
            }
        }
        .el-textarea__inner{
            -webkit-appearance: none;
            transition: none;
            margin: 0;
            outline none;
        }
        .el-input.is-disabled .el-input__inner,.el-textarea.is-disabled .el-textarea__inner{
            color #666666 !important
        }
        .el-upload-list--picture-card .el-upload-list__item,.el-upload--picture-card{
            width: 31%;
        }
    }
    .el-select-dropdown__item{
        font-size .3724rem
    }
    .messageBoardContainer .ml-0 .el-form-item__content{
        display inline-block;
        width 100%
    }
</style>